// Banner — ADB brand rainbow stripe (US-874 · R-4).
//
// Static brand element of the "Atlas Standard" shell: a thin six-band rainbow
// separator (ported from the mockup's `.rainbow`). It carries no feature
// content; feature US never render inside it.
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const Banner = () => {
  const { tokens } = useTheme();
  const { rainbow, layout } = tokens;

  // Hard-edged equal bands, left → right (matches the mockup's linear-gradient).
  const stops = rainbow
    .map((color, i) => {
      const from = ((i / rainbow.length) * 100).toFixed(3);
      const to = (((i + 1) / rainbow.length) * 100).toFixed(3);
      return `${color} ${from}%, ${color} ${to}%`;
    })
    .join(", ");

  return (
    <Box
      aria-hidden
      data-region="banner"
      sx={{
        gridArea: "banner",
        height: `${layout.bannerH}px`,
        backgroundImage: `linear-gradient(to right, ${stops})`,
      }}
    />
  );
};

export default Banner;
